import { createAsyncThunk } from "@reduxjs/toolkit";

import { conditionRuleset } from "./helpers/conditionRuleset";

import { requestStep3 } from "../apiRequests/requestStep3";

export async function payloadCreatorForSize(
  data = { uterumProperties: null },
  thunkAPI
) {
  const state = thunkAPI.getState();
  const { requests, Uterum } = state;
  const { apiConfigs } = requests;

  (!data || Object.keys(data).length === 0) &&
    console.error(`Unexpected data in payloadCreatorForSize: ${data}`);

  Object.keys(data).some(
    (key) =>
      key !== "uterumProperties" &&
      console.error(`Unexpected key in payloadCreatorForSize: ${key}`)
  );

  const response = await requestStep3({
    apiConfigs,
    data:
      data && data.uterumProperties
        ? { ...Uterum, ...data.uterumProperties }
        : Uterum,
    onSuccess: (response) => {
      return {
        ...response,
        data: {
          cgeObj: response.data,
        },
      };
    },
  });

  return response.data;
}

export const requestSize = createAsyncThunk(
  "thunks/requestSize",
  payloadCreatorForSize,
  conditionRuleset
);
